module.exports = __webpack_public_path__ + "assets/img/bannoudesign.74bf85a4.svg";